
import Header from './Header/index.vue'
import Map from './Map/index.vue'
import Banner from './Banner/index.vue'
import GoodsSwiper from './GoodsSwiper/index.vue'
import Title from './Title/index.vue'
import GoodsList from './GoodsList/index.vue'
import Error from './Error/index.vue'
import StoreInfo from './StoreInfo/index.vue'

export {
    Header,
    Banner,
    Map,
    GoodsSwiper,
    Title,
    GoodsList,
    Error,
    StoreInfo
}
